import React from 'react';
import {useEnvironment, useExperiments} from '@wix/yoshi-flow-editor';
import {classes, st} from './LineItemSection.st.css';
import {useLocaleKeys} from '../../../../locale-keys/LocaleKeys';
import {useControllerProps} from '../../Widget/ControllerContext';
import {LineItemRow} from '../LineItem/LineItem';
import {SPECS} from '../../../../common/constants';

export enum LineItemSectionDataHooks {
  root = 'LineItemSectionDataHooks.root',
  list = 'LineItemSectionDataHooks.list',
}

export const LineItemSection = () => {
  const localeKeys = useLocaleKeys();
  const {isMobile} = useEnvironment();
  const {experiments} = useExperiments();
  const {
    checkoutStore: {cart},
  } = useControllerProps();
  const checkoutUIRevampOrderSummary = experiments.enabled(SPECS.CheckoutUIRevampOrderSummary);
  const itemsListClass = checkoutUIRevampOrderSummary ? classes.itemsList : classes.itemsListOld;

  return (
    <div data-hook={LineItemSectionDataHooks.root}>
      <ul
        data-hook={LineItemSectionDataHooks.list}
        className={st(itemsListClass, isMobile ? classes.itemsListMobile : undefined)}
        aria-label={localeKeys.checkout.orderSummary.fullSection.ariaLabel()}>
        {cart.lineItems &&
          cart.lineItems.map((lineItem) => (
            <LineItemRow lineItem={lineItem} key={lineItem.id} useLayoutForLongPrice={cart.hasItemsWithLongPrice} />
          ))}
      </ul>
    </div>
  );
};
